/* eslint-disable import/no-cycle */
import {executePost} from '../requests';

const resourcesName = 'v1/object-locks';

export const ObjectLocksApi = {
  acquire: ({...params}) => executePost(`${resourcesName}/acquire`, params),
  release: ({...params}) => executePost(`${resourcesName}/release`, params),
};
